'use strict';

export {};

type ObjectKeys<T> = T extends object ? ( keyof T )[] : string[];

declare global {
    interface ObjectConstructor {
        keys<T>( o : T ) : ObjectKeys<T>;

        recursiveFreeze : ( obj : object ) => void;
    }
}

Object.recursiveFreeze = function( obj : object ) {
    for ( const value of Object.values( obj ) ) {
        if ( typeof value === 'object' ) {
            Object.recursiveFreeze( value );
        }
    }
    Object.freeze( obj );
};
